export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      roles: ['ADMIN', 'CUST']
    },
    {
      name: 'Orders',
      url: '/orders',
      icon: 'icon-layers',
      roles: ['ADMIN', 'CUST']
    },
    {
      name: 'Inventory',
      url: '/inventory',
      icon: 'icon-list',
      roles: ['ADMIN']
    },
    {
      name: 'Pricing',
      url: '/pricing',
      icon: 'icon-settings',
      roles: ['ADMIN']
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-people',
      roles: ['ADMIN']
    },
    {
      name: 'Settings',
      url: '/setting',
      icon: 'icon-settings',
      roles: ['ADMIN']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js